import { initSwitchableItems } from "@plugins";

window.addEventListener("load", initSwitchableItems(".js-tabs-nav", ".js-tabs-nav-item"));
